import { memo } from "react";
import Alert from "@mui/material/Alert";
import { useSettings } from "hooks";
import { when } from "util/support";
import { NotificationSeverity } from "features/general/types";
import type { MerchantSettings } from "features/merchants/types";
import ShoppingPlatforms from "features/ecommerce/ShoppingPlatforms";
import Resource from "ui/layouts/Resource";
import When from "ui/support/When";
import ConnectECommercePlatform from "./ConnectECommercePlatform";
import ECommerceSettings from "./ECommerceSettings";

const Ecommerce = () => {
    const { getSettings } = useSettings<MerchantSettings>();

    return (
        <Resource
            breadcrumbsProps={{
                heading: 'Welcome to Macropay',
                links: [
                    {
                        name: (
                            <When
                                if={when(
                                    getSettings().platforms,
                                    () => ShoppingPlatforms.make(getSettings().platforms)
                                        .parse()
                                        .toEntries()
                                        .some(([, { isActive }]) => !isActive)
                                )}
                                then={(
                                    <Alert
                                        severity={NotificationSeverity.Success}
                                    >
                                        Your application has been approved!<br />
                                        To start processing payments, please connect your e-commerce platform.
                                    </Alert>
                                )}
                            />
                        )
                    }
                ],
                action: (
                    <ConnectECommercePlatform />
                )
            }}
        >
            <ECommerceSettings />
        </Resource>
    );
};

export default memo(Ecommerce);
